import { ApiResult, CrudService, isNotNullOrUndefinedOrEmpty, Meta } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    NovoValorCommand,
    PdmVersaoAtributoEntity,
    RemoverSaneamentosCommand,
    SaneamentoAtributoEntity,
    SaneamentoPreviaPortalUnicoEntity,
    SaneamentoProdutoEntity
} from '@catalogo/models';
import { SaneamentoAtributosCommand } from '@catalogo/models/saneamento-atributos.command';
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'root' })
export class SaneamentoAtributoDataService extends CrudService<SaneamentoProdutoEntity> {

    urlOriginal: string;
    protected url: string;

    constructor(
        @Inject(OPERACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.urlOriginal = `${urlBase}/v1/Saneamento/<id>`;
    }

    public withPdmVersaoIdProduto(parentId: string) {
        this.url = this.urlOriginal.replace('<id>', parentId) + '/produtos';
        return this;
    }

    public withPdmVersaoIdAtributo(pdmVersaoId: string, saneamentoId?: string) {
        this.url = this.urlOriginal.replace('<id>', pdmVersaoId) + '/atributos';
        if(isNotNullOrUndefinedOrEmpty(saneamentoId)){
            this.url += '?saneamentoId=' + saneamentoId;
        }
        return this;
    }

    public getAtributos = () => this.httpClient.get<ApiResult<PdmVersaoAtributoEntity[]>>(this.url);

    public liberar = (record: string) =>
        this.httpClient.post<ApiResult<string>>(this.urlOriginal.replace('<id>', record) + '/Liberar', record);

    public salvarNovos = (record: NovoValorCommand[]) =>
        this.httpClient.post<ApiResult<NovoValorCommand[]>>(
            this.urlOriginal.replace('<id>', '') + 'NovosValores', record);

    public salvarTodos = (record: SaneamentoAtributosCommand) =>
        this.httpClient.post<ApiResult<SaneamentoAtributosCommand>>(
            this.urlOriginal.replace('<id>', record.saneamentoId) + '/Atributos', record);

    public exportar = (pdmVersaoId: string, meta: Meta) =>
        this.httpClient.post<ApiResult<string>>(this.urlOriginal.replace('<id>', 'Exportar'), { pdmVersaoId, ...meta });

    public remover = (command: RemoverSaneamentosCommand) =>
        this.httpClient.post<ApiResult<boolean>>(this.urlOriginal.replace('<id>', 'Remover'), command);

    public gerarPreviewPortalUnico = (saneamentoId: string, saneamentoAtributos: SaneamentoAtributoEntity[], empresaId: string) =>
        this.httpClient.post<ApiResult<SaneamentoPreviaPortalUnicoEntity>>(this.urlOriginal.replace('<id>', saneamentoId) + '/GerarPreview', {saneamentoAtributos, empresaId});

}
